import { compose } from 'redux'
import { lifecycle, withProps } from 'recompose'
import { withFirebase } from 'react-redux-firebase'
import classes from './CoreLayout.scss'
import { STAGE_TASK_CHOICE } from 'constants'

export default compose(
  withFirebase,
  withProps({ classes }),
  lifecycle({ componentDidMount })
)

export async function componentDidMount() {
  const { firebase } = this.props
  const { protocol, host } = window.location

  // if http and not localhost, then redirect to https
  if (/^http:/.test(protocol) && !/^localhost/.test(host)) {
    window.location = `https://${host}`
  }

  try {
    const {
      user: { uid },
    } = await firebase.auth().signInAnonymously()
    await firebase.update(`users/${uid}`, {
      lastSeen: Date.now(),
      stage: STAGE_TASK_CHOICE,
      uid,
    })
    console.log('User created successfully') // eslint-disable-line no-console
  } catch (err) {
    console.log('User creation failed:', err) // eslint-disable-line no-console
  }
}



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.enhancer.js